import ChatMessage from './ChatMessage'
import TypingIndicator from './TypingIndicator'

const ChatMessageList = ({
  messages,
  typing,
  bottomRef,
  agentData,
  aiLogo,
  selectedProduct,
  onProductSelect,
  onOpenDiagnostics,
  goToPricing,
  loadingText,
  translations,
  language,
}) => {
  return (
    <div className='chat-messages'>
      <div className='chat-inner'>
        {messages.map((message) => (
          <ChatMessage
            key={message.id}
            message={message}
            agentData={agentData}
            aiLogo={aiLogo}
            selectedProduct={selectedProduct}
            onProductSelect={onProductSelect}
            onOpenDiagnostics={onOpenDiagnostics}
            goToPricing={goToPricing}
            loadingText={loadingText}
            translations={translations}
            language={language}
          />
        ))}

        {typing && <TypingIndicator logo={aiLogo} />}

        <div ref={bottomRef} />
      </div>
    </div>
  )
}

export default ChatMessageList
